<template>
  <section class="content">
    <div class="row">
      <v-app>
        <v-content>
          <v-container fluid>

            <v-dialog v-model="newChildOrgDialog" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="title primary--text">Create Child Merchant</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-form ref="createChildMerchantForm" v-model="createChildMerchantFormValid" lazy-validation>
                        <v-text-field 
                          name="name" 
                          label="Name" 
                          v-model="merchant.name"
                          :rules="merchantNameRules"
                          >
                        </v-text-field>

                        <v-text-field 
                          name="merchantId" 
                          label="Merchant Id" 
                          v-model="merchant.merchantId"
                          :rules="merchantIdRules"
                          >
                        </v-text-field>

                        <v-text-field
                         name="comment" 
                         label="Comment" 
                         v-model="merchant.makerComment"
                         :rules="commentRules" 
                         required
                         >
                        </v-text-field>

                        <v-select
                          :items="templates"
                          label="Template"
                          v-model="merchant.templateId"
                          solo
                          item-text="name"
                          item-value="id"
                          :rules="templateRules" 
                          required
                          autocomplete
                        >
                        </v-select>
                      </v-form>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary"  @click.native="closeCreateChildMerchant">Cancel</v-btn>
                <v-btn color="primary"  @click.native="createChildMerchant">CREATE</v-btn>
              </v-card-actions>
              </v-card>
            </v-dialog>
            <v-alert
              value="message" v-if="message"
              type="success"
              outline
            > <span> {{ message }} </span>
            </v-alert>
            
             <v-alert
              value="error" v-if="error"
              type="warning"
              outline
            > <span> {{ error }} </span>
            </v-alert>
            <v-tabs
              fixed-tabs
            >
             <v-tabs-slider color="secondary"></v-tabs-slider>

             <v-tab href="#storestab1">
               Stores
             </v-tab> 

             <v-tab href="#userstab1">
              Users
             </v-tab>

              <v-tab-item
                :value="'storestab' + 1"
                :key="1"
              >
                    <v-toolbar flat color="white" height="17">
                      <v-spacer> </v-spacer>
                      <v-dialog v-model="newstoredialog" max-width="500px">
                        <v-btn small round slot="activator" color="primary" dark class="text-lg-right">Add Store</v-btn>
                       
                        <v-card>
                          <v-card-title>
                            <span class="headline">{{ storeFormTitle }}</span>
                          </v-card-title>
                          <v-card-text>
                            <v-container grid-list-md>
                              <v-layout wrap>
                                <v-form ref="createStoreForm" v-model="createStoreFormValid" lazy-validation>
                                  <v-text-field 
                                    name="storeName" 
                                    label="Store Name" 
                                    v-model="editedStoreItem.name"
                                    :rules="storeNameRules"
                                    >
                                  </v-text-field>

                                  <v-select
                                    :items="paymentChannels"
                                    label="Payment Channel"
                                    v-model="editedStoreItem.identifierType"
                                    solo
                                    :rules="paymentChannelRules" 
                                    required
                                    >
                                  </v-select>

                                  <v-text-field 
                                    name="paymentIdentifier" 
                                    label="Channel Identifier" 
                                    v-model="editedStoreItem.storeIdentifier"
                                    :rules="channelIdentifierRules" 
                                    required>
                                  </v-text-field>
                                </v-form>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="secondary"  @click.native="closeAddNewStore">Cancel</v-btn>
                          <v-btn color="primary"  @click.native="saveAddNewStore">Save</v-btn>
                        </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  
                    
                   
                    <v-data-table
                      :headers="headers"
                      :items="stores"
                      :pagination.sync="pagination"
                      :total-items="totalStores"
                      :loading="loading"
                      class="elevation-1"
                      item-key="storeId"
                    >
                    <template
                        slot="headerCell"
                        slot-scope="{ header }"
                      >
                        <span
                          class="body-2 font-weight-regular accent--text"
                          v-text="header.text"
                        />
                      </template>
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.storeId }}</td>
                        <td>{{ props.item.name }}</td>
                        <td>{{ props.item.storeIdentifier }}</td>
                        <td>{{ props.item.identifierType }}</td>
                        <td>{{ props.item.createdAt }}</td>
                        <td class="justify-center layout px-0">
                          <v-icon
                            small
                            class="mr-2"
                            @click="editStoreItem(props.item)"
                          >
                            edit
                          </v-icon>
                        </td>
                      </template>
                      <template slot="no-data">
                        <p> No data Found </p>
                        <v-btn color="primary" @click="getDataFromApi">Reload</v-btn>
                      </template>
                    </v-data-table>
                  
              </v-tab-item>

              <v-tab-item
                :value="'userstab' + 1"
                :key="2"
              >
                <v-toolbar flat color="white" height="20">
                  <v-spacer> </v-spacer>
                    <v-dialog v-model="newuserdialog" max-width="700px">
                        <v-btn small slot="activator" round color="primary" dark class="">Add User</v-btn>
                       
                        <v-card>
                          <v-card-title pt-4>
                            <span class="headline">{{ userFormTitle }}</span>
                          </v-card-title>
                          <v-card-text>
                                <v-form ref="createUserForm" v-model="createUserFormValid" lazy-validation>
                              <v-container grid-list-md fluid>
                              <v-layout wrap row>
                                <v-flex d-flex xs12 sm6 md6>
                                  <v-text-field 
                                    name="firstname" 
                                    label="First Name" 
                                    v-model="editedUserItem.firstName"
                                    :rules="firstNameRules"
                                    required>
                                  </v-text-field>
                                </v-flex>
                                <v-flex d-flex xs12 sm6 md6>
                                  <v-text-field
                                   name="lastname" 
                                   label="Last Name" 
                                   v-model="editedUserItem.lastName"
                                   :rules="lastNameRules" 
                                   required
                                   >
                                  </v-text-field>
                                </v-flex>
                                <v-flex d-flex xs12 sm12 md12>
                                  <v-text-field 
                                   name="Email Address" 
                                   label="Email Address" 
                                   v-model="editedUserItem.username"
                                   :rules="userNameRules" 
                                   required
                                   >
                                  </v-text-field>
                                </v-flex>

                                <v-layout>
                                <v-flex xs6 v-if="this.editedUserIndex !== -1">
                                  <v-select
                                    :items="activeNames"
                                    label="Active"
                                    v-model="editedUserItem.active"
                                    required
                                  >
                                  </v-select>
                                </v-flex>
                                <v-flex xs6 v-if="this.editedUserIndex !== -1">
                                  <v-select
                                    :items="accountStatusNames"
                                    label="Account Status"
                                    v-model="editedUserItem.accountStatus"
                                    required
                                  >
                                  </v-select>
                                </v-flex>
                                </v-layout>
                               
                                  <v-flex xs6 v-if="hasChildren">
                                    <v-autocomplete
                                      v-model="selectedChild"
                                      :items="children"
                                      item-text="name"
                                      item-value="id"
                                      label="Organization"
                                      @change="getOrgStores()"
                                    ></v-autocomplete>
                                  </v-flex>

                                  <v-flex xs6>
                                    <v-checkbox
                                      v-model="selectAllStores"
                                      label="Select All Stores"
                                    ></v-checkbox>
                                  </v-flex>
                               
                                  <v-flex 12>
                                     <h4> Selected Stores </h4>
                                     <v-chip color="green" :key="selected" v-for="selected in editedUserItem.selectedStores">{{ selected }}</v-chip>
                                  </v-flex>

                                  <v-data-iterator
                                    :items="stores"
                                    :rows-per-page-items="rowsPerPageItems"
                                    :pagination.sync="paginationStores"
                                    content-tag="v-layout"
                                    row
                                    wrap
                                  >
                                    <v-flex
                                      slot="item"
                                      slot-scope="props"
                                      xs12
                                      sm6
                                      md4
                                      lg6
                                    >
                                      <v-checkbox :label="props.item.name" :key="props.item.storeId" v-model="editedUserItem.selectedStores" :value="props.item.name">
                                      </v-checkbox>
                                    </v-flex>
                                  </v-data-iterator>
                                  </v-layout>
                                  </v-container>
                                </v-form>
                              
                          </v-card-text>
                          <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="secondary" @click.native="closeAddNewUser">Cancel</v-btn>
                          <v-btn color="primary" @click.native="saveAddNewUser">Save</v-btn>
                        </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>


                      <v-data-table
                      :headers="userHeaders"
                      :items="users"
                      :pagination.sync="pagination"
                      :total-items="totalUsers"
                      :loading="loading"
                      class="elevation-1"
                      >
                      <template
                        slot="headerCell"
                        slot-scope="{ header }"
                      >
                        <span
                          class="body-2 font-weight-regular accent--text"
                          v-text="header.text"
                        />
                      </template>
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.id }}</td>
                        <td>{{ props.item.firstName }}</td>
                        <td>{{ props.item.lastName }}</td>
                        <td>{{ props.item.username }}</td>
                         <td>{{ props.item.accountStatus }}</td>
                        <td>{{ props.item.active }}</td>
                        <td class="justify-center layout px-0">
                          <v-icon
                            small
                            class="mr-2"
                            @click="editUserItem(props.item)"
                          >
                            edit
                          </v-icon>
                          <v-icon
                            small
                            class="mr-2"
                            @click="deleteItem(props.item)"
                          >
                            delete
                          </v-icon>
                        </td>
                      </template>
                      <template slot="no-data">
                        <p> No data Found </p>
                        <v-btn color="primary" @click="getDataFromApi">Reload</v-btn>
                      </template>
                    </v-data-table>
                
              </v-tab-item>

            </v-tabs>
            <v-layout row wrap>
            <v-flex xs6>
            <router-link class="pageLink" to="/merchant/view"> <v-btn> Go Back </v-btn> </router-link>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
            <v-btn  color="primary" round small mt-4 @click="showCreateChildMerchant"> Create Child Merchant </v-btn>
            </v-flex>
           </v-layout>
           <v-dialog v-model="deleteDialog" max-width="500px">
                  <v-card>
                    <v-card-text>
                      <p> Are you sure you want to delete user {{user.username}} ? </p>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn flat @click="deleteDialog=false"> Cancel </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="triggerDeleteItem"> Delete </v-btn>
                    </v-card-actions>
                  </v-card>
            </v-dialog>
          </v-container>
        </v-content>
      </v-app>
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
  name: 'merchantconfig',
  data: function() {
    return {
      headers: [
        {text: 'Id', value: 'id'},
        {
          text: 'Name',
          value: 'name'
        },
        { text: 'Channel Id', value: 'storeIdentifier' },
        { text: 'Channel', value: 'identifierType' },
        { text: 'Created At', value: 'createdAt' }
      ],
      userHeaders: [
        {text: 'Id', value: 'id'},
        {
          text: 'First Name',
          value: 'firstName'
        },
        { text: 'Last Name', value: 'lastName' },
        { text: 'username', value: 'UserName' },
        { text: 'Account Status', value: 'accountStatus' },
        { text: 'Active', value: 'active' }
      ],
      newstoredialog: false,
      newuserdialog: false,
      stores: [],
      storeNames: [],
      store: {
        'name': '',
        'storeIdentifier': '',
        'identifierType': ''
      },
      users: [],
      totalUsers: 0,
      user: {
        'firstName': '',
        'lastName': '',
        'username': '',
        'accountStatus': '',
        'active': '',
        selectedStores: []
      },
      message: '',
      error: '',
      loading: true,
      pagination: {},
      totalStores: 0,
      dialog: false,
      editedStoreIndex: -1,
      editedUserIndex: -1,
      defaultStoreItem: {
        id: '',
        name: '',
        storeIdentifier: '',
        identifierType: ''
      },
      editedStoreItem: {
        'id': '',
        'name': '',
        'storeIdentifier': '',
        'identifierType': ''
      },
      defaultUserItem: {
        firstName: '',
        lastName: '',
        username: '',
        active: '',
        accountStatus: ''
      },
      editedUserItem: {
        'firstName': '',
        'lastName': '',
        'username': '',
        'active': '',
        'accountStatus': '',
        'selectedStores': []
      },
      merchant: {
        'name': '',
        'merchantId': '',
        'makerComment': ''
      },
      createStoreFormValid: true,
      createUserFormValid: true,
      storeNameRules: [
        v => !!v || 'Store Name is required'
      ],
      paymentChannelRules: [
        v => !!v || 'Payment Channel is required'
      ],
      channelIdentifierRules: [
        v => !!v || 'Channel Identifier is required'
      ],
      firstNameRules: [
        v => !!v || 'First Name is required'
      ],
      lastNameRules: [
        v => !!v || 'Last Name is required'
      ],
      userNameRules: [
        v => !!v || 'Username is required'
      ],
      templateRules: [
        v => !!v || 'Template is required'
      ],
      paymentChannels: ['POS', 'MCOOP-CASH', 'MPESA'],
      rowsPerPageItems: [4, 8, 12],
      paginationStores: {
        rowsPerPage: 4
      },
      accountStatusNames: ['LOCKED', 'NOT LOCKED'],
      activeNames: ['ACTIVE', 'NOT ACTIVE'],
      newChildOrgDialog: false,
      createChildMerchantFormValid: true,
      merchantNameRules: [
        v => !!v || 'Merchant Name is required'
      ],
      merchantIdRules: [
        v => !!v || 'Merchant Id is required'
      ],
      commentRules: [
        v => !!v || 'Comment is required'
      ],
      children: [],
      selectedChild: '',
      selectAllStores: false,
      allStoreNames: [],
      deleteDialog: false,
      templates: []
    }
  },
  watch: {
    pagination: {
      handler () {
      },
      deep: true
    },
    selectAllStores: function () {
      if (this.selectAllStores) {
        console.log('getting all stores, and add to selected stores array')
        this.editedUserItem.selectedStores = this.allStoreNames
      } else {
        // empty array
        this.editedUserItem.selectedStores = []
      }
    }
  },
  mounted () {
    this.getDataFromApi()
      .then(data => {
      })
    this.getUserDataFromApi()
      .then(data => {
      })
    this.getOrganizationChildren()
    this.getllStores()
    this.getTemplates()
  },
  computed: {
    storeFormTitle () {
      return this.editedStoreIndex === -1 ? 'New Store' : 'Edit Store'
    },
    userFormTitle () {
      return this.editedUserIndex === -1 ? 'Add User' : 'Edit User'
    },
    hasChildren () {
      if (this.children.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let merchantId = this.$route.params.id
        let items = this.getStores(merchantId)
        const total = items.length

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    getUserDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let items = this.getUsers()
        const total = items.length

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    editStoreItem (item) {
      this.editedStoreIndex = this.stores.indexOf(item)
      this.editedStoreItem = Object.assign({}, item)
      this.newstoredialog = true
    },
    closeAddNewStore () {
      this.newstoredialog = false
      setTimeout(() => {
        this.editedStoreItem = Object.assign({}, this.defaultStoreItem)
        this.editedStoreIndex = -1
        this.createStoreFormValid = true
      }, 300)
    },
    saveAddNewStore () {
      if (this.$refs.createStoreForm.validate()) {
        console.log(this.editedStoreIndex)
        if (this.editedStoreIndex === -1) {
          this.createStore()
        } else {
          this.updateStore()
        }
        this.closeAddNewStore()
      }
    },
    editUserItem (item) {
      this.editedUserIndex = this.users.indexOf(item)
      this.editedUserItem = Object.assign({}, item)
      this.newuserdialog = true
    },
    closeAddNewUser () {
      this.newuserdialog = false
      setTimeout(() => {
        this.editedUserIndex = Object.assign({}, this.defaultUserItem)
        this.editedUserIndex = -1
      }, 300)
    },
    saveAddNewUser () {
      if (this.$refs.createUserForm.validate()) {
        if (this.editedUserIndex > -1) {
          this.userRequest('update')
        } else {
          this.editedUserItem.accountStatus = 'NOT LOCKED'
          this.editedUserItem.active = 'ACTIVE'
          this.userRequest('create')
        }
        this.closeAddNewUser()
      }
    },
    createStore() {
      var url = config.serverURI + '/merchant/' + this.$route.params.id + '/store/create'
      var token = store.state.token
      console.log(this.editedStoreItem)
      this.message = ''
      this.error = ''
      axios.post(url, this.editedStoreItem, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('Update Response:', response)
            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }

            if (response.data.error === true) {
              this.error = response.data.message
              return
            }

            this.message = response.data.message
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
    },
    updateStore() {
      var url = config.serverURI + '/merchant/' + this.$route.params.id + '/store/update'
      var token = store.state.token
      this.message = ''
      this.error = ''
      console.log(this.editedStoreItem)
      axios.post(url, this.editedStoreItem, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('Update Response:', response)
            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }

            if (response.data.error === true) {
              this.error = response.data.message
              return
            }

            this.message = response.data.message
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
    },
    getStores (merchantId) {
      var url = config.serverURI + '/merchant/' + merchantId + '/stores'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.stores = response.data
            this.totalStores = this.stores.total

            const mapFunction = p => p.name
            this.storeNames = this.stores.map(mapFunction)
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.stores
    },
    userRequest(requestType) {
      this.message = ''
      this.error = ''
      var url = config.serverURI + '/user/' + this.$route.params.id + '/merchantuser/' + requestType
      var token = store.state.token
      console.log(this.editedUserItem)
      axios.post(url, this.editedUserItem, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          console.log('API Response:', response)

          if (response.status !== 200) {
            this.error = response.statusText
            console.log('Error is ' + this.error)
            return
          }
          if (response.data.error !== false) {
            this.error = response.data.message
            console.log('Error is ' + this.error)
            return
          }
          this.editedUserIndex = Object.assign({}, this.defaultUserItem)
          this.message = response.data.message
        })
        .catch(error => {
          // Request failed.
          console.log('error', error.response)
          var data = error.response.data
          this.newuserdialog = false
          console.log(data.message)
          if (data.message === 'Unauthorized') {
            console.log('redirecting')
            window.location = '/login'
          } else {
            this.error = data.status + ' ' + data.message
          }
        })
    },
    getUsers () {
      var url = config.serverURI + '/merchant/' + this.$route.params.id + '/users'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.users = response.data
            this.totalUsers = this.users.total
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.users
    },
    showCreateChildMerchant () {
      this.newChildOrgDialog = true
    },
    closeCreateChildMerchant () {
      this.newChildOrgDialog = false
    },
    createChildMerchant () {
      if (this.$refs.createChildMerchantForm.validate()) {
        let url = config.serverURI + '/merchant/create'
        let token = store.state.token
        this.merchant.parentId = this.$route.params.id
        axios.post(url, this.merchant, {
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json'
          }
        })
          .then(response => {
            console.log('API Response:', response)
            if (response.data.error !== false) {
              this.error = response.data.message
              console.log('Error is ' + this.error)
              return
            }
            // this.resetMerchantObject()
            this.message = response.data.message
            this.closeCreateChildMerchant()
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            if (data.message === 'Unauthorized' || error.response.status === 401) {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      }
    },
    getOrganizationChildren () {
      var url = config.serverURI + '/merchant/' + this.$route.params.id + '/children'
      let token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)
            this.children = response.data
            if (this.children.length > 0) {
              var parent = {name: 'parent', id: '0'}
              this.children.unshift(parent)
            }
          })
          .catch(error => {
            console.log('error', error.response)
            var data = error.response.data
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.children
    },
    getOrgStores () {
      this.stores = []
      let merchantId = 0
      if (this.selectedChild === '0') {
        merchantId = this.$route.params.id
      } else {
        merchantId = this.selectedChild
      }
      this.getStores(merchantId)
    },
    getllStores () {
      var url = config.serverURI + '/merchant/' + this.$route.params.id + '/allstores'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)
            console.log('Merchant id ==> ', this.$route.params.id)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            var allstores = response.data
            const mapFunction = p => p.name
            this.allStoreNames = allstores.map(mapFunction)
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.allStoreNames
    },
    deleteItem (item) {
      this.user = item
      this.deleteDialog = true
    },
    triggerDeleteItem () {
      this.message = ''
      this.error = ''
      var url = config.serverURI + '/user/' + this.$route.params.id + '/merchantuser/delete'
      var token = store.state.token
      axios.post(url, this.user, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          console.log('API Response:', response)
          this.deleteDialog = false
          if (response.status !== 200) {
            this.error = response.statusText
            console.log('Error is ' + this.error)
            return
          }
          if (response.data.error !== false) {
            this.error = response.data.message
            console.log('Error is ' + this.error)
            return
          }
          this.message = response.data.message
        })
        .catch(error => {
          var data = error.response.data
          this.deleteDialog = false
          if (data.message === 'Unauthorized') {
            console.log('redirecting')
            window.location = '/login'
          } else {
            this.error = data.status + ' ' + data.message
          }
        })
    },
    getTemplates () {
      var url = config.serverURI + '/merchant/templates'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.templates = response.data
          })
          .catch(error => {
            console.log('error', error.response)
            var data = error.response
            console.log(data)
            if (data.status === 401) {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
    }
  }
}

</script>
<style>
.info-box {
  cursor: pointer;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// merchantconfig.vue?7c981b70